import { searchBusinessApplications } from "services/SauceService";

export async function influencersLoader(props: any) {
  const url = new URL(props.request.url);
  const businessId = localStorage.getItem("businessId");
  const tabStatus = url.searchParams.get("status") || "pending";
  if (!businessId) {
    return [];
  }
  const response: any = await searchBusinessApplications({
    businessId,
    tabStatus,
  });
  return response;
}
